import { FC } from "react";
import styles from "./styles.module.css";

import { GradientButton } from "components/GradientButton";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { routesEnum } from "pages/Routes";
import { useUser } from "api/auth";

const LookingForMore: FC = () => {
  const { data: me } = useUser({ enabled: false });

  return (
    <div className="container-lg">
      <h1 className={styles.title}>Looking for more?</h1>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <div className={styles.card}>
            <img
              src="/images/hackathon/explore_project.png"
              alt="explore_project"
            />
            <div>
              <h3>Projects</h3>
              <p>Create or Join Projects, Find Collaborators and just BUIDL!</p>
            </div>
            <Link to={routesEnum.software}>
              <GradientButton color="outlined">Explore Project</GradientButton>
            </Link>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <div className={styles.card}>
            <img src="/images/hackathon/explore_team.png" alt="explore_team" />
            <div>
              <h3>Teams</h3>
              <p>Find Like-minded People to Create, Buidl, and Network with!</p>
            </div>
            <GradientButton color="outlined">Explore Teams</GradientButton>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <div className={styles.card}>
            <img
              src="/images/hackathon/explore_portfolio.png"
              alt="explore_portfolio"
            />
            <div>
              <h3>Portfolio</h3>
              <p>
                Show off your skills! Easily create and share your portfolio!
              </p>
            </div>
            <Link
              to={
                me
                  ? `${routesEnum.portfolio}/${me?.userName}`
                  : routesEnum.signIn
              }
            >
              <GradientButton color="outlined">
                Explore Portfolio
              </GradientButton>
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LookingForMore;
